import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Paper,
  FormControl,
  Grid,
  InputLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ConfirmationDialog from "../../../common/ConfirmationDialog";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import { useContext } from "react";
import AppDataContext from "../../../common/appContext";
import AppConstatnts from "../../../common/AppConstants";
import Loader from "../../../sharedComponents/loader/loader";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";
import {
  getDropDown,
  getInputBox,
} from "../../../sharedComponents/formFields/LabelInFormFields";
import DataGridCustom from "../../../sharedComponents/dataGrid/DataGridCustom";

const ProfessionalExperienceViewUpdate = ({
  eventId,
  playerID,
  gridPropsData,
  styles,
  setAlert,
  setAlertType,
  setAlertMessage,
  viewProfile,
  // user,
}) => {
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const { user } = useContext(AppDataContext);
  const formData = {
    id: 0,
    playerID: playerID,
    eventId: eventId,
    years: "",
    countryId: 0,
    countryName: "",
    league: "",
    clubName: "",
    contact: "",
    phone: "",
    userBy: null,
    mode: null,
  };
  const defaultErrors = {
    years: false,
  };
  const defaultErrorMsg = {
    years: "",
  };
  const [profExpGridData, setProfExpGridData] = useState([]);
  const [profExpFormData, setProfExpFormData] = useState({});
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [countryDropdownList, setCountryDropdownList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deletedRowID, setDeletedRowId] = useState(-1);
  const [error, setError] = useState(defaultErrors);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMsg);
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1570 ? 1 : "none"
  );
  const columns = [
    { field: "id", hide: true, flex: 1 },
    {
      field: "years",
      headerName: "Club Year",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "countryName",
      headerName: "Country of Club",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "league",
      headerName: "League",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "clubName",
      headerName: "Club",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "contact",
      headerName: "Club Contact",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "phone",
      headerName: "Club Contact Phone",
      width: 180,
      flex: columnFlex,
    },
  ];

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  useEffect(() => {
    fetchDropdownDataforPlayer();
    setProfExpFormData(formData);
    setProfExpGridData(gridPropsData);
  }, [gridPropsData]);

  //---UTILs---
  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1570 ? 1 : "none");
  };

  const toggleAlert = (open, type, message) => {
    setAlert(open);
    setAlertType(type);
    setAlertMessage(message);
  };

  const toggleError = (key, val, message) => {
    setError({ ...error, [key]: val });
    setErrorMessage({ ...errorMessage, [key]: message });
  };

  const resetError = () => {
    setError(defaultErrors);
    setErrorMessage(defaultErrorMsg);
  };

  //dynamic error validation, check for all keys,
  //if in-case multiple error validations in future
  const validateErrors = () => {
    let valid = true;
    Object.keys(error).forEach((key) => {
      valid = valid && !error[key];
    });
    if (!valid) {
      toggleAlert(true, "warning", "Please correct the invalid fields.");
    }
    return valid;
  };

  const checkIfSaveBtnDisabled = () => {
    return profExpFormData.years ||
      profExpFormData.countryId ||
      profExpFormData.league ||
      profExpFormData.clubName ||
      profExpFormData.contact ||
      profExpFormData.phone
      ? false
      : true;
  };

  //---HANDLERS---

  //single handler to open and close confirmation box for delete
  const handleOpenCloseConfirmationBox = (val) => {
    if (val === false) {
      setDeletedRowId(-1);
    }
    setOpenConfirmationBox(val);
  };

  //1. find the Int/Prof experience details to edit from grid data
  //2. set the input boxes with Int/Prof experience details to edit
  //3. set userBy to current user -- for DB record
  const handleRowEditClick = (id) => {
    resetError();
    setIsUpdate(true);
    let result = profExpGridData.find((e, i) => {
      return e.id === id;
    });
    setProfExpFormData({ ...result, userBy: user?.loginID });
  };

  const handleRowDeleteClick = (id) => {
    setDeletedRowId(id);
    handleOpenCloseConfirmationBox(true);
  };

  //reset the input boxes with initially declared empty formData
  const handleCancelUpdate = () => {
    resetError();
    setIsUpdate(false);
    setProfExpFormData(formData);
  };

  //1. validate then call api to save
  //2. after save reset necessary values
  const handleSaveCLick = () => {
    if (!checkIfSaveBtnDisabled() && validateErrors()) {
      const result = handleSubmit(profExpFormData);
      if (result) {
        handleCancelUpdate();
        toggleAlert(true, "success", "Data uploaded successfully.");
      }
    }
  };

  //1. find the record to delete from grid data
  //2. set the mode to "delete" --- for DB
  //3. after delete reset necessary values
  const handleDeleteClick = () => {
    let record = profExpGridData.find((e, i) => {
      return e.id === deletedRowID;
    });
    if (record) {
      const updatedForm = {
        ...record,
        mode: "delete",
        userBy: user.loginID,
      };
      const result = handleSubmit(updatedForm);
      if (result) {
        handleCancelUpdate();
        handleOpenCloseConfirmationBox(false);
        toggleAlert(
          true,
          "success",
          "Internationl/Professional Experience record deleted Successfully."
        );
      }
    }
  };

  const handleInputChange = (e, key) => {
    let value = e.target.value;
    let defaultVal = "";
    switch (key) {
      case "years":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.YEAR_REGEX)
        )
          toggleError(key, true, "Invalid Year");
        else toggleError(key, false, "");
        break;
      case "countryId":
        let result = countryDropdownList.find((c, i) => {
          return c.childID === value;
        });
        setProfExpFormData({
          ...profExpFormData,
          [key]: value || null,
          countryName: result.childID ? result.childName : "",
        });
        return;
    }
    setProfExpFormData({
      ...profExpFormData,
      [key]: value || defaultVal,
    });
  };

  //---APIs---

  const fetchDropdownDataforPlayer = async () => {
    try {
      const countryList = await PlayerProfileService.getPlayerCountryList();
      setCountryDropdownList([
        { childID: "", childName: "None" },
        ...countryList.data,
      ]);
    } catch (error) {
      console.error("Error while fetching Dropdown data:", error);
    }
  };

  //to create, update or delete a record -- common api
  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const result =
        await PlayerProfileService.insertUpdateProfExperienceDetails(formData);
      if (result) {
        getUpdatedProfExpGridData();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toggleAlert(true, "error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  //get updated records after creating, updating or deleting record, for view
  const getUpdatedProfExpGridData = async () => {
    try {
      const result = await PlayerProfileService.getPlayersProfileData(
        playerID,
        eventId,
        user?.loginID
      );
      setProfExpGridData(result.data.intProfExperience);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <Paper square elevation={5} className={classes.paperStyle}>
        <Grid container>
          <Grid
            item
            lg={10}
            md={10}
            sm={10}
            xs={10}
            className={classes.sectionTitlePadding}
          >
            <Typography
              noWrap
              variant="subtitle1"
              fontWeight="medium"
              color="secondary"
            >
              International/Professional Experience
            </Typography>
          </Grid>
          {!viewProfile ? (
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              xs={2}
              className={classes.inputSectionPadding}
            >
              <Box>
                {isUpdate ? (
                  <Button
                    className={classes.cancelButton}
                    size={classes.submitButtonSize}
                    variant={styles.cancelButton.variant}
                    title={styles.cancelButton.title}
                    onClick={handleCancelUpdate}
                  >
                    <TitleTooltip title="Cancel">
                      <CancelOutlinedIcon
                        sx={{ color: styles.cancelButton.cancelIconColor }}
                      />
                    </TitleTooltip>
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  disabled={checkIfSaveBtnDisabled()}
                  onClick={handleSaveCLick}
                >
                  <TitleTooltip title="Save Professional Details">
                    <SaveOutlinedIcon />
                  </TitleTooltip>
                </Button>
              </Box>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {!viewProfile ? (
          <Grid
            key={0}
            container
            pl={2}
            pr={2}
            spacing={2}
            justifyContent={"start"}
          >
            <Grid item lg={1.5} md={6} sm={12} xs={12}>
              {getInputBox(
                "Club Year",
                profExpFormData.years,
                (e) => handleInputChange(e, "years"),
                false,
                "text",
                error.years
                // errorMessage.years
              )}
            </Grid>
            <Grid item lg={2.5} md={6} sm={12} xs={12}>
              {getDropDown(
                "Country of Club",
                profExpFormData.countryId,
                (e) => handleInputChange(e, "countryId"),
                countryDropdownList
              )}
            </Grid>
            <Grid item lg={2} md={6} sm={12} xs={12}>
              {getInputBox("League", profExpFormData.league, (e) =>
                handleInputChange(e, "league")
              )}
            </Grid>
            <Grid item lg={2} md={6} sm={12} xs={12}>
              {getInputBox("Club", profExpFormData.clubName, (e) =>
                handleInputChange(e, "clubName")
              )}
            </Grid>
            <Grid item lg={2} md={6} sm={12} xs={12}>
              {getInputBox("Club Contact", profExpFormData.contact, (e) =>
                handleInputChange(e, "contact")
              )}
            </Grid>
            <Grid item lg={2} md={6} sm={12} xs={12}>
              {getInputBox("Club Contact Phone", profExpFormData.phone, (e) =>
                handleInputChange(e, "phone")
              )}
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12} className={classes.dataGridPadding}>
          <DataGridCustom
            classes={classes}
            styles={styles}
            columns={columns}
            rows={profExpGridData}
            viewProfile={viewProfile}
            handleRowEditClick={handleRowEditClick}
            handleRowDeleteClick={handleRowDeleteClick}
          />
          <ConfirmationDialog
            keepMounted
            open={openConfirmationBox}
            onClose={() => handleOpenCloseConfirmationBox(false)}
            onSubmit={handleDeleteClick}
          />
        </Grid>
      </Paper>
    </>
  );
};
export default React.memo(ProfessionalExperienceViewUpdate);
